module.exports = __webpack_public_path__ + "img/skridsko_efterberg.20451e79.jpg";